import datastore from "../store/hoa-datastore";

function checkVisibility(obj: any, keyToCheck: string) {
	if (typeof obj !== "object" || obj === null) return false;

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			if (key === keyToCheck && obj[key].isVisible === true) {
				return true;
			}
			if (typeof obj[key] === "object") {
				const result = checkVisibility(obj[key], keyToCheck);
				if (result) return true;
			}
		}
	}
	return false;
}


function getNotVisibleKeys(obj: any, type: string): string[] {
	let visibleKeys: string[] = [];
	let queue: any[] = [obj];

	while (queue.length > 0) {
		const current = queue.shift(); 

		if (typeof current !== "object" || current === null) continue;

		for (const key in current) {
			if (current.hasOwnProperty(key)) {
				if (current[key].isVisible === false) {
					const value = current[key].fieldName[0];

					if (type === "overview") {
						if (overViewDetailsTitle[value]) {
							visibleKeys.push(overViewDetailsTitle[value]);
						}
					}
					if (type === "procedure") {
						if (ProcedureTitle[value]) {
							visibleKeys.push(ProcedureTitle[value]);
						}
					}
					if (type === "violation") {
						if (key === "Email" || key === "Portal" || key === "Other") {
							visibleKeys.push(key);
						} else {
							if (violationRegulationTitle[value]) {
								visibleKeys.push(violationRegulationTitle[value]);
							}
						}
					}
				}

				if (typeof current[key] === "object") {
					queue.push(current[key]);
				}
			}
		}
	}

	return visibleKeys;
}

// function getNotVisibleKeys(obj: any, type: string): string[] {
// 	let visibleKeys: string[] = [];

// 	if (typeof obj !== "object" || obj === null) return visibleKeys;

// 	for (const key in obj) {
// 		if (obj.hasOwnProperty(key)) {
// 			if (obj[key].isVisible === false) {
// 				const value = obj[key].fieldName[0];
// 				if (type === "overview") {
// 					if (overViewDetailsTitle[value]) {
// 						visibleKeys.push(overViewDetailsTitle[value]);
// 					}
// 				}
// 				if (type === "procedure") {
// 					if (ProcedureTitle[value]) {
// 						visibleKeys.push(ProcedureTitle[value]);
// 					}
// 				}
// 				if (type === "violation") {
// 					if (key === "Email" || key === "Portal" || key === "Other") {
// 						visibleKeys.push(key);
// 					} else {
// 						if (violationRegulationTitle[value]) {
// 							visibleKeys.push(violationRegulationTitle[value]);
// 						}
// 					}
// 				}
// 			}
// 			if (typeof obj[key] === "object") {
// 				visibleKeys = visibleKeys.concat(getNotVisibleKeys(obj[key], type));
// 			}
// 		}
// 	}

// 	return visibleKeys;
// }

function getNotVisibleKeysForViolationTab(obj: any): string[] {
	let visibleKeys: string[] = [];
	let stack = [obj];

	while (stack.length > 0) {
		const current = stack.pop();

		if (typeof current !== "object" || current === null) continue;

		for (const key in current) {
			if (current.hasOwnProperty(key)) {
				if (current[key].isVisible === false) {
					visibleKeys.push(key);
				}
				if (typeof current[key] === "object") {
					stack.push(current[key]);
				}
			}
		}
	}

	return visibleKeys;
}

function mappingNotVisibleKeys(dataConfig: any) {
	datastore.notVisibleItemOfOverview = {
		"Basic Information": getNotVisibleKeys(
			dataConfig["Overview"]["Basic Information"],
			"overview"
		),
		"Additional Information": getNotVisibleKeys(
			dataConfig["Overview"]["Additional Information"],
			"overview"
		),
		"Client Information": getNotVisibleKeys(
			dataConfig["Overview"]["Client Information"],
			"overview"
		),
	};
	datastore.notVisibleItemOfProcedure = {
		"HOA Registration Renewal Information": getNotVisibleKeys(
			dataConfig["Procedures"]["HOA Registration Renewal Information"],
			"procedure"
		),
		"HOA Leasing Regulations And Restrictions": getNotVisibleKeys(
			dataConfig["Procedures"]["Hoa Leasing Regulations & Restrictions"],
			"procedure"
		),
	};
	datastore.notVisibleItemOfViolation = {
		"Basic Information": getNotVisibleKeys(
			dataConfig["Violation Regulation"]["Basic Information"],
			"violation"
		),
		"Other Restriction in Place and Fees": getNotVisibleKeys(
			dataConfig["Violation Regulation"]["Other Restrictions in Place and Fees"],
			"violation"
		),
	};
	datastore.notVisibleItemOfViolationTab["Landscaping"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Landscaping"]
	);
	datastore.notVisibleItemOfViolationTab["Trash"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Trash"]
	);
	datastore.notVisibleItemOfViolationTab["Parking"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Parking"]
	);
	datastore.notVisibleItemOfViolationTab["Nuisance"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Nuisance"]
	);
	datastore.notVisibleItemOfViolationTab["Structure"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Structure"]
	);
	datastore.notVisibleItemOfViolationTab["Others"] = getNotVisibleKeysForViolationTab(
		dataConfig["Violation Regulation"]["Others"]
	);
}

export { mappingNotVisibleKeys, checkVisibility };

const overViewDetailsTitle: any = {
	objectId: "ID",
	market: "Market",
	zip: "Zip",
	coordinates: "Coordinates",
	phone: "Contact Number",
	email: "Email",
	fees: "HOA Fees",
	paymentFrequency: "Payment Frequency",
	hoaFeesPaymentDeadline: "HOA Fees Payment Deadline",
	hoaPaymentInformation: "HOA Payment Information",
	boardMeetingSchedule: "Board Meeting Schedule",
	propertyManagerName: "Property Manager Name",
	propertyManagerCompanyAddress: "Property Manager Company Address",
	propertyManagerPhone: "Property Manager Phone",
	propertyManagerEmail: "Property Manager Email",
	residentGateAccessRequirement: "Gate Access Requirement",
	isGateAccessRequired: "Gated Area",
	guestAccessPermission: "Guest Access",
	isPortalAccessRequired: "Portal Access",
	residentLoginAvailable: "Resident login",
	hoaPortalLink: "HOA Portal link",
	pmcPortalLink: "PMC Portal Link",
	communityServices: "Community Services",
	hoaClientInfo: "Client Information",
};

const ProcedureTitle: any = {
	registrationAndRenewalInstruction: "Registration & Renewal Instructions",
	renewalFee: "Renewal Fee",
	AdditionalInformationOfRenewalFee: "Additional Information",
	leasingRegulationsAndRestrictions: "Leasing Regulations And Restrictions",
	keywords: "Categories",
	sourceDocuments: "Source Documents",
	reference: "Reference",
	leasingCap: "Leasing Cap",
	AdditionalInformationOfLeasingCap: "Additional Information",
	leasingRestrictionDate: "Effective Date of Leasing Restriction",
	AdditionalInformationOfDateOfLeasing: "Additional Information",
	tenantLeaseRegistrationRenewalForm: "Tenant or Lease Registration/Renewal Form",
	registrationAddminFee: "Registrations Admin Fee",
};

const violationRegulationTitle: any = {
	minViolationFees: "Violation Fees (min)",
	maxViolationFees: "Violation Fees (max)",
	curePeriod: "Cure Period",
	violationPayment: "Violation Payment",
	notificationType: "Notification Type",
	Portal: "Portal",
	Email: "Email",
	Other: "Other",
	gracePeriod: "Grace Period",
	assessmentFee: "Assessment Fee",
	assessmentViolationFee: "Assessment Violation Fee",
	assessmentFrequency: "Assessment Frequency",
};
